import { v4 as uuidv4 } from 'uuid';
import {UATProject, UATStatus, TestCase} from "../types/UATProject";

export const updateUATProject = (uatUUID: string, updatedProject: UATProject): boolean => {
    const existingUATs = JSON.parse(localStorage.getItem("UAT") || "[]") as UATProject[];
    const projectIndex = existingUATs.findIndex(project => project.id === uatUUID);

    if (projectIndex === -1) return false;

    existingUATs[projectIndex] = {
        ...existingUATs[projectIndex],
        ...updatedProject,
        updated_at: new Date()
    };
    localStorage.setItem("UAT", JSON.stringify(existingUATs));
    return true;
};

export const updateUATProjectAttribute = <K extends keyof UATProject>(uatUUID: string, attribute: K, value: UATProject[K]): boolean => {
  const existingUATs = JSON.parse(localStorage.getItem("UAT") || "[]") as UATProject[];
  const projectIndex = existingUATs.findIndex((project) => project.id === uatUUID);
  if (projectIndex === -1) return false;

  existingUATs[projectIndex] = {
    ...existingUATs[projectIndex],
    [attribute]: value,
    updated_at: new Date(),
  };

  localStorage.setItem("UAT", JSON.stringify(existingUATs));
  return true;
};

export const updateTestCaseAttribute = <K extends keyof TestCase>(uatUUID: string, testCaseIdentifier: { name: string; orderId: string } | number, attribute: K, value: TestCase[K]): boolean => {
    const existingUATs = JSON.parse(localStorage.getItem("UAT") || "[]") as UATProject[];
    const projectIndex = existingUATs.findIndex((project) => project.id === uatUUID);
    if (projectIndex === -1) return false;
    let testCaseIndex: number;

    if (typeof testCaseIdentifier === 'number') {
        testCaseIndex = testCaseIdentifier;
    } else {
        testCaseIndex = existingUATs[projectIndex].testCases.findIndex(
          (tc) =>
            tc.name === testCaseIdentifier.name &&
            tc.order.id === testCaseIdentifier.orderId
        );
    }

  if (testCaseIndex === -1) return false;

    existingUATs[projectIndex].testCases[testCaseIndex] = {
        ...existingUATs[projectIndex].testCases[testCaseIndex],
        [attribute]: value
    };
    existingUATs[projectIndex].updated_at = new Date();
    
    localStorage.setItem("UAT", JSON.stringify(existingUATs));
    return true;
}

export const fetchUATProject = (projectID: string): UATProject | undefined => {
    const uat = localStorage.getItem("UAT");
    if (uat) {
        const projects = JSON.parse(uat) as UATProject[];
        return projects.find(project => project.id === projectID);
    }
    return undefined;
}

export const newUUID = () => {
    return uuidv4();
}

export const allMarketplacesMap = () => {
    return [
        { label: "United States", value: "US" },
        { label: "Germany", value: "DE" },
        { label: "Japan", value: "JP" },
        { label: "United Kingdom", value: "GB" },
        { label: "France", value: "FR" },
        { label: "Spain", value: "ES" },
        { label: "India", value: "IN" },
        { label: "Canada", value: "CA" },
        { label: "Netherlands", value: "NL" },
        { label: "Italy", value: "IT" },
        { label: "Australia", value: "AU" },
        { label: "Poland", value: "PL" },
        { label: "Sweden", value: "SE" },
        { label: "Belgium", value: "BE" },
        { label: "Turkey", value: "TR" },
        { label: "Mexico", value: "MX" },
        { label: "Brazil", value: "BR" },
        { label: "Argentina", value: "AR" },
        { label: "Chile", value: "CL" },
        { label: "Colombia", value: "CO" },
        { label: "Costa Rica", value: "CR" },
        { label: "Dominican Republic", value: "DO" },
        { label: "Guatemala", value: "GT" },
        { label: "Paraguay", value: "PY" },
        { label: "Peru", value: "PE" },
        { label: "Denmark", value: "DK" },
        { label: "Finland", value: "FI" },
        { label: "Norway", value: "NO" },
        { label: "Portugal", value: "PT" },
        { label: "South Africa", value: "ZA" },
        { label: "Nigeria", value: "NG" },
        { label: "Kenya", value: "KE" },
        { label: "Czech Republic", value: "CZ" },
        { label: "Hungary", value: "HU" },
        { label: "Iceland", value: "IS" },
        { label: "Ireland", value: "IE" },
        { label: "Romania", value: "RO" },
        { label: "Switzerland", value: "CH" },
        { label: "Indonesia", value: "ID" },
        { label: "Malaysia", value: "MY" },
        { label: "New Zealand", value: "NZ" },
        { label: "Philippines", value: "PH" },
        { label: "Taiwan", value: "TW" }
    ];

}